module.exports = __webpack_public_path__ + "img/25.d84a7369.png";